/* MAVERICS Heritage — storefront interactions */
(function () {
  'use strict';
  const money = (cents) => {
    const fmt = window.MAV_MONEY_FORMAT || '₹{{amount}}';
    const v = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v);
  };

  const overlay = document.getElementById('drawer-overlay');
  const drawer = document.getElementById('cart-drawer');
  const itemsEl = document.getElementById('drawer-items');
  const totalEl = document.getElementById('drawer-total');
  const countEls = document.querySelectorAll('[data-cart-count]');

  function setCount(n) {
    countEls.forEach((el) => {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    setCount(cart.item_count);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="link-underline" href="/collections/all">Browse the collection</a></div>';
      if (totalEl) totalEl.closest('.drawer__foot').style.display = 'none';
      return;
    }
    if (totalEl) totalEl.closest('.drawer__foot').style.display = '';
    itemsEl.innerHTML = cart.items.map((it) => `
      <div class="drawer__item" data-key="${it.key}">
        <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_160x$1$2') : ''}" alt="${it.title}"></a>
        <div>
          <a class="di-title" href="${it.url}">${it.product_title}</a>
          <div class="qty" data-key="${it.key}">
            <button data-act="dec" aria-label="Decrease">–</button>
            <span>${it.quantity}</span>
            <button data-act="inc" aria-label="Increase">+</button>
          </div>
          <button class="di-remove" data-remove="${it.key}">Remove</button>
        </div>
        <div class="price">${money(it.final_line_price)}</div>
      </div>`).join('');
    if (totalEl) totalEl.querySelector('[data-total]').textContent = money(cart.total_price);
  }

  function fetchCart() {
    fetch('/cart.js').then((r) => r.json()).then(renderCart);
  }

  function change(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then((r) => r.json()).then(renderCart);
  }

  // Add to cart (product forms + quick add)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then((r) => r.json())
      .then(() => { fetchCart(); openDrawer(); })
      .catch(() => {})
      .finally(() => { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // Quick-add buttons (single-variant cards)
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault();
      const id = q.getAttribute('data-quick-add');
      q.disabled = true; const t = q.textContent; q.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then((r) => r.json()).then(() => { fetchCart(); openDrawer(); })
        .finally(() => { q.disabled = false; q.textContent = t; });
    }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]') || e.target.id === 'drawer-overlay') closeDrawer();
    const rem = e.target.closest('[data-remove]');
    if (rem) change(rem.getAttribute('data-remove'), 0);
    const qb = e.target.closest('.drawer .qty button');
    if (qb) {
      const wrap = qb.closest('.qty');
      const cur = parseInt(wrap.querySelector('span').textContent, 10);
      change(wrap.getAttribute('data-key'), qb.dataset.act === 'inc' ? cur + 1 : cur - 1);
    }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // PDP quantity stepper
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.pdp__buy .qty button, .cart-page .qty button');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    if (!input) return;
    let v = parseInt(input.value, 10) || 1;
    v = b.dataset.act === 'inc' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // PDP gallery
  const thumbs = document.querySelectorAll('.pdp__thumbs button');
  const mainImg = document.querySelector('.pdp__main img');
  thumbs.forEach((t) => t.addEventListener('click', () => {
    thumbs.forEach((x) => x.classList.remove('active'));
    t.classList.add('active');
    if (mainImg) mainImg.src = t.getAttribute('data-full');
  }));

  // Mobile nav + accordions
  const mnav = document.getElementById('mnav');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mnav-open]')) { mnav && mnav.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-mnav-close]')) { mnav && mnav.classList.remove('open'); document.body.style.overflow = ''; }
    const tog = e.target.closest('.mnav__toggle');
    if (tog) {
      const open = tog.getAttribute('aria-expanded') === 'true';
      tog.setAttribute('aria-expanded', String(!open));
      const sub = tog.nextElementSibling;
      if (sub) sub.classList.toggle('open', !open);
    }
  });

  // Scroll reveal
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((ents) => {
    ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { threshold: 0.12 }) : null;
  document.querySelectorAll('.reveal').forEach((el) => io ? io.observe(el) : el.classList.add('in'));

  // ---- Collection: mobile filter drawer ----
  const sidebar = document.getElementById('plp-sidebar');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-filter-open]')) { sidebar && sidebar.classList.add('open'); document.body.classList.add('filter-lock'); }
    if (e.target.closest('[data-filter-close]')) { sidebar && sidebar.classList.remove('open'); document.body.classList.remove('filter-lock'); }
    // collapse/expand a facet
    const fh = e.target.closest('.facet__head');
    if (fh) {
      const open = fh.getAttribute('aria-expanded') !== 'false';
      fh.setAttribute('aria-expanded', String(!open));
      const body = fh.nextElementSibling;
      if (body) body.style.display = open ? 'none' : '';
    }
  });

  // Auto-submit facet form when a checkbox changes
  const facetForm = document.getElementById('facet-form');
  if (facetForm) {
    facetForm.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"]')) facetForm.submit();
    });
  }

  // ---- Load more ----
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#load-more');
    if (!btn) return;
    const url = btn.getAttribute('data-load-more');
    if (!url) return;
    btn.disabled = true; btn.textContent = 'Loading…';
    fetch(url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newCards = doc.querySelectorAll('#plp-grid > .card');
      const grid = document.getElementById('plp-grid');
      newCards.forEach((c) => {
        grid.appendChild(c);
        if ('IntersectionObserver' in window) c.classList.add('in'); else c.classList.add('in');
      });
      const shown = document.getElementById('shown-count');
      if (shown) shown.textContent = grid.querySelectorAll('.card').length;
      const nextBtn = doc.querySelector('#load-more');
      if (nextBtn) {
        btn.setAttribute('data-load-more', nextBtn.getAttribute('data-load-more'));
        btn.disabled = false; btn.textContent = 'Load more';
      } else {
        btn.remove();
      }
    }).catch(() => { btn.disabled = false; btn.textContent = 'Load more'; });
  });

  // ---- Quick view ----
  const qv = document.getElementById('quick-view');
  const qvOverlay = document.getElementById('qv-overlay');
  const qvBody = document.getElementById('qv-body');

  function openQV() { qv.classList.add('open'); qvOverlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeQV() { qv.classList.remove('open'); qvOverlay.classList.remove('open'); document.body.style.overflow = ''; }

  function renderQV(p) {
    const img = p.featured_image || (p.images && p.images[0]) || '';
    const onSale = p.compare_at_price && p.compare_at_price > p.price;
    let priceHtml = onSale
      ? `<s>${money(p.compare_at_price)}</s> ${money(p.price)}`
      : money(p.price);
    let variantHtml = '';
    if (p.variants && p.variants.length > 1) {
      variantHtml = `<select class="qv__variant" aria-label="Variant">` +
        p.variants.map((v) => `<option value="${v.id}" ${v.available ? '' : 'disabled'}>${v.title}${v.available ? '' : ' — sold out'}</option>`).join('') +
        `</select>`;
    } else if (p.variants && p.variants.length === 1) {
      variantHtml = `<input type="hidden" class="qv__variant" value="${p.variants[0].id}">`;
    }
    const soldOut = !p.available;
    qvBody.innerHTML = `
      <div class="qv__media"><img src="${img.replace(/(\.[^.?]+)(\?.*)?$/, '_720x$1$2')}" alt="${p.title}"></div>
      <div class="qv__info">
        ${p.vendor ? `<span class="card__vendor">${p.vendor}</span>` : ''}
        <h2>${p.title}</h2>
        <div class="qv__price">${priceHtml}</div>
        <div class="qv__buy">
          ${variantHtml}
          <div class="qty"><button type="button" data-act="dec" aria-label="Decrease">–</button><input value="1" min="1" type="number" aria-label="Quantity"><button type="button" data-act="inc" aria-label="Increase">+</button></div>
        </div>
        <button class="btn btn--brass qv__add" ${soldOut ? 'disabled' : ''}>${soldOut ? 'Sold out' : 'Add to cart'}</button>
        <a class="link-underline qv__full" href="/products/${p.handle}">View full details</a>
      </div>`;

    const addBtn = qvBody.querySelector('.qv__add');
    if (addBtn && !soldOut) {
      addBtn.addEventListener('click', () => {
        const sel = qvBody.querySelector('.qv__variant');
        const id = sel ? (sel.value || sel.getAttribute('value')) : null;
        const q = parseInt(qvBody.querySelector('.qv__buy .qty input').value, 10) || 1;
        addBtn.disabled = true; addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: q })
        }).then((r) => r.json()).then(() => { fetchCart(); closeQV(); openDrawer(); })
          .finally(() => { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; });
      });
    }
    // qty stepper inside QV
    qvBody.querySelectorAll('.qv__buy .qty button').forEach((b) => b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      let val = parseInt(input.value, 10) || 1;
      input.value = b.dataset.act === 'inc' ? val + 1 : Math.max(1, val - 1);
    }));
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-quick-view]');
    if (!t) return;
    e.preventDefault();
    const handle = t.getAttribute('data-quick-view');
    qvBody.innerHTML = '<div class="qv__loading">Loading…</div>';
    openQV();
    fetch(`/products/${handle}.js`).then((r) => r.json()).then(renderQV)
      .catch(() => { qvBody.innerHTML = '<div class="qv__loading">Could not load. <a href="/products/' + handle + '">Open product page</a></div>'; });
  });
  document.addEventListener('click', (e) => { if (e.target.closest('[data-qv-close]')) closeQV(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeQV(); });

  fetchCart();
})();
